import React from 'react';
import { dataKeyAttribute, dataIndexAttribute } from '../../constants';
function Separator({ className, id, index, refs }) {
    const ref = React.useRef(null);
    refs[index] = ref;
    return (React.createElement("div", Object.assign({ className: className }, { [dataKeyAttribute]: id, [dataIndexAttribute]: index }, { ref: ref })));
}
export default React.memo(Separator);
